import { render, staticRenderFns } from "./tab-repickup.vue?vue&type=template&id=688cc65f&"
import script from "./tab-repickup.vue?vue&type=script&lang=js&"
export * from "./tab-repickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports